import { useTranslation } from 'react-i18next';
import { VerificationOfPayeeComponentTypes } from './VerificationOfPayeeComponent.types';
import Typography from '../../sharedComponents/Typography/Typography';
import format from '../../utils/format';
import styles from './verification-of-payee-component.module.scss';

const VerificationOfPayeeComponent: React.FC<
  VerificationOfPayeeComponentTypes
> = ({ verificationOutcomeReadOnly = [] }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {verificationOutcomeReadOnly.map((item, index) => (
        <div
          key={`${item.type}-${item.timestamp}-${index}`}
          className={styles.outcomeContainer}
        >
          <div className={styles.row}>
            <Typography variant="label-3">
              {t('sunshine.content.vop_check_type')}
            </Typography>
            <Typography variant="body-2">
              {format.snakeCaseToLabel(item.type)}
            </Typography>
          </div>

          <div className={styles.row}>
            <Typography variant="label-3">
              {t('sunshine.content.vop_result')}
            </Typography>
            <Typography variant="body-2">
              {format.snakeCaseToLabel(item.outcome)}
            </Typography>
          </div>

          {!!item.recommendedUpdates.length && (
            <div
              className={`${styles.recommendedContainer} ${styles.suggestedUpdatesContainer}`}
            >
              <Typography variant="label-3">
                {t('sunshine.content.vop_suggested_updates')}
              </Typography>
              {item.recommendedUpdates.map((update, updateIndex) => (
                <div
                  key={`${update.path}-${updateIndex}`}
                  className={styles.recommendedRow}
                >
                  <Typography variant="body-2">
                    {format.camelCaseToLabel(update.path)}
                  </Typography>
                  <Typography variant="body-2">{update.value}</Typography>
                </div>
              ))}
            </div>
          )}

          {!!item.message && (
            <div className={`${styles.row} ${styles.messageRow}`}>
              <Typography variant="label-3">
                {t('sunshine.content.vop_message')}
              </Typography>
              <Typography variant="body-2">{item.message}</Typography>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VerificationOfPayeeComponent;
